import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { helpCenterApi, type HelpArticleListParams } from '../api/help-center-api';

import { helpCenterKeys } from './help-center-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function helpArticleListQueryOptions(storeId: string, params: HelpArticleListParams) {
  return queryOptions({
    queryKey: helpCenterKeys.articleList(storeId, params),
    queryFn: () => helpCenterApi.listArticles(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useHelpArticles(storeId: string, params: HelpArticleListParams) {
  return useQuery(helpArticleListQueryOptions(storeId, params));
}
